import React from 'react';
import PropTypes from 'prop-types';
import NextImage from 'next/image';
import { Tooltip } from '@web/atoms/Tooltip';
import {
  Card,
  Info,
  StyledImage,
  Name,
  Description,
  CardContent,
  CardHeader,
} from './styles.js';

export const ImageCard = ({
  label,
  title,
  description,
  checked = false,
  img,
  onChange,
  unavailable,
  unavailableText,
  notSelectable,
  notSelectableText = 'To choose this item, please remove one of your previous selections.',
  level,
  textDirection = 'column',
  titleColor = 'text.primary',
  checkedBackgroundColor = 'background.checked',
  borderColor = 'secondary.plum',
  checkedBorderColor = 'secondary.plum',
}) => {
  const getImageCard = props => (
    <Card
      {...props}
      checked={checked}
      unavailable={unavailable}
      $notSelectable={notSelectable}
      aria-label={`${label} ${title}`}
      onClick={!notSelectable && onChange}
      $checkedBackgroundColor={checkedBackgroundColor}
      $borderColor={borderColor}
      $checkedBorderColor={checkedBorderColor}
    >
      <CardContent>
        <StyledImage checked={checked} unavailable={unavailable}>
          <NextImage src={img.src} alt={img.alt} width={82} height={82} />
        </StyledImage>
        <Info $textDirection={textDirection}>
          <CardHeader>
            <Name as={level} $titleColor={titleColor}>
              {title}
            </Name>
          </CardHeader>
          <Description $textDirection={textDirection}>
            {unavailable ? unavailableText : description}
          </Description>
        </Info>
      </CardContent>
    </Card>
  );

  return (notSelectable && !unavailable) || unavailable ? (
    <Tooltip trigger={getImageCard} placement="top" offsetY={-200}>
      {notSelectableText}
    </Tooltip>
  ) : (
    getImageCard()
  );
};

ImageCard.displayName = 'ImageCard';
ImageCard.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  textDirection: PropTypes.oneOf(['row', 'column']),
  titleColor: PropTypes.string,
  unavailable: PropTypes.bool,
  unavailableText: PropTypes.string,
  unavailableLabel: PropTypes.string,
  notSelectable: PropTypes.bool,
  notSelectableText: PropTypes.string,
  description: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  checkedBackgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  checkedBorderColor: PropTypes.string,
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
